import { RAW_UPDATE } from './action-types';

export const makeRawUpdate = (path, value) => ({
  type: RAW_UPDATE,
  path,
  value,
});
